import { useMemo, useState } from "react";
import { projects } from "../data/siteContent";
import useReveal from "../hooks/useReveal";

function ProjectCard({ item, index }) {
  const ref = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`project-card-${index}`}
      className="reveal group relative overflow-hidden bg-brand-charcoal"
      style={{ transitionDelay: `${index * 50}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          loading="lazy"
          className="card-img w-full h-full object-cover opacity-95 group-hover:opacity-100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
      </div>
      <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
        <p className="text-[10px] md:text-xs tracking-[0.35em] uppercase text-brand-red mb-2 font-semibold">
          {item.category}
        </p>
        <h3 className="font-serif text-xl md:text-2xl text-white leading-tight mb-2">
          {item.title}
        </h3>
        <p className="text-xs md:text-sm text-white/80 leading-relaxed max-h-0 overflow-hidden group-hover:max-h-24 transition-all duration-500">
          {item.description}
        </p>
      </div>
    </article>
  );
}

export default function Projects() {
  const [filter, setFilter] = useState("Όλα");

  const filtered = useMemo(
    () =>
      filter === "Όλα"
        ? projects.items
        : projects.items.filter((p) => p.category === filter),
    [filter]
  );

  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-10">
          <p className="text-xs tracking-[0.35em] uppercase text-brand-red mb-5 font-medium">
            <span className="inline-block w-10 h-px bg-brand-red align-middle mr-4" />
            {projects.eyebrow}
          </p>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl text-brand-charcoal leading-[1.1] tracking-tight mb-6">
            {projects.title}
          </h2>
          <p className="text-base md:text-lg text-neutral-600 leading-relaxed">
            {projects.subtitle}
          </p>
        </div>

        <div
          data-testid="projects-filters"
          className="flex flex-wrap gap-x-8 gap-y-3 mb-12 border-b border-brand-greyBorder pb-4"
        >
          {projects.filters.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              data-testid={`filter-${f}`}
              className={`filter-underline text-xs md:text-sm tracking-widest uppercase font-semibold pb-2 transition-colors ${
                filter === f
                  ? "text-brand-red active"
                  : "text-brand-charcoal hover:text-brand-red"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {filtered.map((item, i) => (
            <ProjectCard key={item.title} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
